import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './stil.css';

const wurzel = document.getElementById('wurzel');
if (!wurzel) throw new Error('Das Wurzelelement fehlt in index.html.');

createRoot(wurzel).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
